import React, { useEffect, useState } from "react";
import Topbar from "../../components/Topbar/Topbar";
import CommonMmc from "./CommonMmc";
import StateMmc from "./StateMmc";
import StateMmcEdit from "./StateMmcEdit";
import SpecialMmc from "./SpecialMmc";
import { URLS } from "../../Services/Constant";
import { get } from "../../Services/ApiHandler";
import SpecialOfferMmc from "./SpecialOfferMmc";

const MMCCategory = () => {
  const tabs = ["Common MMC", "State MMC", "Special Offer MMC"];
  const [stateEdit, setStateEdit] = useState(false);
  const [offerEdit, setOfferEdit] = useState(false);
  const [active, setActive] = useState(tabs[0]);
  const [mmcData, setMmcData] = useState({
    commonMMC: {},
    statesMMC: [],
    offerMMC: [],
  });
  const [mappedStates, setMappedStates] = useState([]);
  const [mappedProperties, setMappedProperties] = useState([]);
  const [optionsList, setOptionsList] = useState({
    states: [],
    plans: [],
  });

  const handleFilter = (d, s) => {
    if (!d || !s) return !d ? [] : d;
    let ids = new Set(s?.map((item) => item?.id));
    let filtered = d?.filter((item) => !ids.has(item?.id));
    console.log("filtered", filtered);
    return filtered;
  };

  const handleChange = (key, val) => {
    setMmcData((prev) => ({ ...prev, [key]: val }));
  };

  const getPlans = async () => {
    if (optionsList.plans?.length === 0) {
      let plansRes = await get(`${URLS.MMC_PLANS}`);
      if (plansRes?.status === "success") {
        let plansMapped = plansRes?.data?.map((item) => ({
          ...item,
          label: item?.name,
          value: item?.id,
        }));
        handleChange(
          "commonMMC",
          plansRes?.data?.find((item) => item?.is_default),
        );
        setOptionsList((prev) => ({
          ...prev,
          plans: plansMapped?.filter((item) => !item?.is_default),
        }));
      }
    }
  };

  const getOptionsList = async () => {
    const res = await get(`${URLS.LOCATION}?type=2`);

    console.log("LOCATION API RESPONSE:", res);

    if (res?.status === "success") {
      const mapped = (res?.data ?? []).map((item) => ({
        ...item,
        label: item.name,
        value: item.id,
      }));

      console.log("MAPPED STATES:", mapped);

      setOptionsList((prev) => ({
        ...prev,
        states: mapped,
      }));

      return mapped;
    }

    return [];
  };
  useEffect(() => {
    getPlans();
  }, []);

  const getStateOptions = () => {
    const allStates = optionsList?.states ?? [];

    const currentStates = stateEdit?.data?.states ?? [];

    const currentStateIds = new Set(
      currentStates.map((item) => item?.value ?? item?.id),
    );

    const mappedStateIds = new Set(
      (mappedStates ?? []).map((item) => item?.id ?? item?.value),
    );

    return allStates.filter((state) => {
      const stateId = state?.id ?? state?.value;

      // Edit mode: keep states already selected for this plan
      if (currentStateIds.has(stateId)) {
        return true;
      }

      // Remove states already assigned to another plan
      return !mappedStateIds.has(stateId);
    });
  };

  return (
    <div>
      <Topbar header={"MMC Master"} back={true} />
      <h5>MMC Category</h5>

      {/* tab buttons */}
      <div className="d-flex ac-jb">
        <div className="d-flex ac-js gap-3 pt-3">
          {tabs.map((tab, index) => {
            return (
              <button
                onClick={async () => {
                  if (tab !== "Common MMC") {
                    await getOptionsList();
                  }
                  setActive(tab);
                  setStateEdit(false);
                  setOfferEdit(false);
                }}
                className={`rounded-3 border-1 f1 fs-sm-10 fs-md-12 fs-lg-13 fs-xl-14 fs-xxl-16 p-2 ps-3 pe-3 ${active === tab ? "bg-primar border-0 text-white" : "bg-white"}`}
                key={index}
              >
                {tab}
              </button>
            );
          })}
        </div>
        {active !== "Common MMC" && !stateEdit && !offerEdit && (
          <button
            className="f2 fs-sm-10 fs-md-12 fs-lg-13 fs-xl-14 fs-xxl-16 white push-btn bg-primar"
            onClick={() =>
              active === "State MMC"
                ? setStateEdit({ type: "add" })
                : setOfferEdit({ type: "add" })
            }
          >
            + Add {active}
          </button>
        )}
      </div>

      {console.log("optionsList", optionsList)}
      {/* tab data  */}
      <div className="mt-3">
        {active === "Common MMC" ? (
          <CommonMmc data={mmcData.commonMMC} />
        ) : active === "State MMC" ? (
          Boolean(stateEdit) ? (
            <StateMmcEdit
              setStateEdit={setStateEdit}
              data={stateEdit?.data ?? {}}
              type={stateEdit?.type}
              optionsList={{
                plans: handleFilter(optionsList?.plans, mmcData?.statesMMC),
                states: optionsList?.states ?? [],
              }}
            />
          ) : (
            <StateMmc
              setStateEdit={setStateEdit}
              setMappedStates={setMappedStates}
              setList={(e) => handleChange("statesMMC", e)}
              list={mmcData.statesMMC}
            />
          )
        ) : Boolean(offerEdit) ? (
          <SpecialMmc
            optionsList={{
              plans: handleFilter(optionsList?.plans, mmcData?.offerMMC),
              states: optionsList?.states,
            }}
            data={offerEdit?.data ?? {}}
            setOfferEdit={setOfferEdit}
            type={offerEdit?.type}
            mappedProperties={handleFilter(
              mappedProperties,
              offerEdit?.data?.properties,
            )}
            handleFilter={handleFilter}
          />
        ) : (
          <SpecialOfferMmc
            setOfferEdit={setOfferEdit}
            setList={(e) => {
              handleChange("offerMMC", e);
              setMappedProperties(
                (e ?? []).flatMap((item) => item?.properties),
              );
            }}
            list={mmcData.offerMMC}
          />
        )}
      </div>
    </div>
  );
};

export default MMCCategory;
